import { MessageSquare, Smartphone, Star, Users } from 'lucide-react'
import React from 'react'


const Trust = () => {
  return (
     <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <div className="mb-12">
            <p className="text-gray-600 mb-8">
              Trusted by 10,000+ businesses worldwide
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              <div className="bg-green-50 p-6 rounded-xl">
                <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center mb-4 mx-auto">
                  <Smartphone className="w-5 h-5 text-green-600" />
                </div>
                <h3 className="font-bold text-gray-900 mb-2">
                  Meta WhatsApp Partner
                </h3>
                <p className="text-sm text-gray-600">
                  Official Meta Business Partner for WhatsApp Business API
                  integration
                </p>
              </div>

              <div className="bg-blue-50 p-6 rounded-xl">
                <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mb-4 mx-auto">
                  <Users className="w-5 h-5 text-blue-600" />
                </div>
                <h3 className="font-bold text-gray-900 mb-2">ISV Onboarding</h3>
                <p className="text-sm text-gray-600">
                  Certified Independent Software Vendor for WhatsApp Business
                  Platform
                </p>
              </div>

              <div className="bg-purple-50 p-6 rounded-xl">
                <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center mb-4 mx-auto">
                  <MessageSquare className="w-5 h-5 text-purple-600" />
                </div>
                <h3 className="font-bold text-gray-900 mb-2">
                  White-label SMS
                </h3>
                <p className="text-sm text-gray-600">
                  Complete white-label reseller program for SMS messaging
                  solutions
                </p>
              </div>
            </div>

            <div className="flex items-center justify-center mt-8">
              <div className="flex items-center space-x-1">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-5 h-5 text-yellow-400 fill-current"
                  />
                ))}
                <span className="text-gray-600 ml-2">
                  4.9/5 from 2,500+ reviews
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
  )
}

export default Trust